export const PATTERN_TYPES = {
  ROTATION: 'rotation',
  OFFSET: 'offset',
} as const;

export type PatternType = (typeof PATTERN_TYPES)[keyof typeof PATTERN_TYPES];

export const PATTERN_SCOPE_VALUES = {
  NONE: 'none',
  CHARACTER: 'character',
  WORD: 'word',
} as const;

export type PatternScope =
  (typeof PATTERN_SCOPE_VALUES)[keyof typeof PATTERN_SCOPE_VALUES];

export type PresetConfig = {
  label: string;
  translationKey: string;
  character: {
    rotation: string;
    offset: string;
    rotationIntensity: number;
    offsetIntensity: number;
  };
  word: {
    rotation: string;
    offset: string;
    rotationIntensity: number;
    offsetIntensity: number;
  };
};

export const PRESET_KEYS = ['Fridge Magnet', 'Wave', 'Bounce'] as const;

export type PresetConfigKey = (typeof PRESET_KEYS)[number];

export type PatternNumber =
  | 1
  | 2
  | 3
  | 4
  | 5
  | 6
  | 7
  | 8
  | 9
  | 10
  | 11
  | 12
  | 13
  | 14
  | 15
  | 16
  | 17
  | 18
  | 19
  | 20
  | 21
  | 22
  | 23
  | 24
  | 25
  | 26
  | 27
  | 28
  | 29
  | 30;

export type PatternKeys =
  | `rotation-pattern-${PatternNumber}`
  | `offset-pattern-${PatternNumber}`;
export type PatternCountsKeys = `${PatternKeys}-enabled`;

export type Config = {
  keys: Partial<Record<string, PatternKeys>>;
  defaultCounts: Partial<Record<PatternCountsKeys, '0'>>;
  countsKeys: Partial<Record<string, PatternCountsKeys>>;
};

export type ValidationFailureReason =
  | { type: 'maxValues' }
  | { type: 'invalidCharacter' }
  | { type: 'outOfRange'; min: number; max: number };

export type ValidationResult =
  | { isValid: true }
  | { isValid: false; reason: ValidationFailureReason };
